export default function getNextFileForUpload({ state, props, path }) {
  const files = state.get('media.uploading')
  let localToken = localStorage.getItem('bmsToken')
  const file = Object.keys(files).reduce((acc, key) => {
    if (acc === null && !files[key].moved) {
      const { node } = files[key]
      acc = {
        file: files[key],
        key,
        headers: {
          node,
          clientId: key,
          token: localToken
        }
      }
    }
    return acc
  }, null)

  if (file) {
    return path.next(file)
  }

  return path.end()
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/getNextFileForUpload.js